import { t } from '@/i18n';
import { z } from 'zod';
import { businessForm } from '../../../_models/project';

/// ////////////////////////////////////////////
/// enum
/// ////////////////////////////////////////////

export const fundBusinessForm = businessForm.extract([
  /** 補助等に関する交付決定実績 */
  'subsidy',
  /** 出資実績 */
  'investment',
  /** 債務保証実績 */
  'debt-guarantee',
  /** 貸付実績 */
  'loan',
  /** その他 */
  'others',
]);

export const FundBusinessFormTitleModifier = {
  subsidy: t('fund-business-subsidy-title'),
  investment: t('fund-business-investment-title'),
  'debt-guarantee': t('fund-business-debt-guarantee-title'),
  loan: t('fund-business-loan-title'),
  others: t('fund-business-others-title'),
} as const satisfies Record<z.infer<typeof fundBusinessForm>, string>;

export const fundBusinessForInvestmentPerformanceType = z.enum([
  'decision',
  'execution',
]);

export const FundBusinessForInvestmentPerformanceTitleModifier = {
  decision: t('decision'),
  execution: t('fund-business-execution'),
} as const satisfies Record<
  z.infer<typeof fundBusinessForInvestmentPerformanceType>,
  string
>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

const FundBusinessCellModel = z.object({
  count: z.number().int().nonnegative().nullable(),
  amount: z.number().nullable(),
});

const FundBusinessYearCellModel = z.object({
  amountInfo: FundBusinessCellModel.nullish(),
});

const FundBusinessYearCellsModel = FundBusinessYearCellModel.array();

export const FundBusinessRowModel = z.object({
  id: z.string(),
  title: z.string().nullable(),
  decidedAmountInfo: FundBusinessCellModel.nullish(),
  estimatedAmountInfo: FundBusinessCellModel.nullish(),
  yearAmountInfos: FundBusinessYearCellsModel,
});

const FundBusinessBaseModel = z.object({
  businessForm,
  title: z.string().nullable(),
  performances: FundBusinessRowModel.array(),
  priorId: z.string().nullish(),
});

export const FundBusinessModel = FundBusinessBaseModel.extend({
  id: z.string().uuid(),
  // 基金シートと出資状況表で返ってくるenumが違うので注意
  businessForm,
});

export const FundBusinessesModel = FundBusinessModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const FundBusinessUpdateFormSchema = FundBusinessBaseModel;
export type FundBusinessFormValues = z.infer<
  typeof FundBusinessUpdateFormSchema
>;

export const FundBusinessUpsertMutationParamsSchema =
  FundBusinessBaseModel.extend({
    title: z.string().nullish(),
  });

export const FundBusinessForInvestmentUpsertFormSchema =
  FundBusinessBaseModel.pick({
    businessForm: true,
    performances: true,
  }).extend({
    title: z.string().nullish(),
  });

export const FundBusinessCreateFormSchema = z.object({
  title: z.string().nullish(),
  businessForm: fundBusinessForm,
});
